<script setup lang="ts">
type Props = {
  activeCountdown?: boolean;
};

const { activeCountdown = true } = defineProps<Props>();

const getCountdownTimer = function (time: number) {
  localStorage.setItem('init_countdown', JSON.stringify(time));

  const countdownFromLocalStorage: any =
    localStorage.getItem('start_countdown');

  let timer;

  try {
    if (countdownFromLocalStorage) {
      timer = JSON.parse(countdownFromLocalStorage);
    }
  } catch (ex) {}
  if (countdownFromLocalStorage && timer && timer.hours && timer.minutes) {
    return (
      parseInt(timer.hours) * 3600 +
      parseInt(timer.minutes) * 60 +
      parseInt(timer.seconds)
    );
  } else {
    return time;
  }
};

const countdownDiv = ref<HTMLDivElement | null>(null);
</script>

<template>
  <WidgetsCountdown
    v-if="activeCountdown"
    ref="countdownDiv"
    :class="$style.countdownContainer"
    :restart="true"
    :total-time="getCountdownTimer(600)"
  >
    <template #process="{ time }">
      <div :class="$style.timerWrapper">
        <span :class="$style.timer">{{ time.hours }}</span>
        <span :class="$style.colon">:</span>
        <span :class="$style.timer">{{ time.minutes }}</span>
        <span :class="$style.colon">:</span>
        <span :class="$style.timer">{{ time.seconds }}</span>
      </div>
    </template>
    <template #finish>
      <span class="hidden"></span>
    </template>
  </WidgetsCountdown>
</template>

<style module lang="postcss">
.countdownContainer {
  @apply m-0;

  .timerWrapper {
    @apply flex items-center gap-1;
    .timer {
      @apply text-xs md:text-sm font-bold grid place-items-center rounded bg-success/15 text-success w-[25px] h-[25px] md:w-[28px] md:h-[28px];
    }
    .colon {
      @apply text-xs md:text-sm font-semibold text-success/40;
    }
  }
}
</style>
